import governanceSaga from './sagas/GovernanceSaga';
import busStopPerformanceSaga from './sagas/BusStopPerformanceSaga';
import vehicleReportSaga from './sagas/VehicleReportSaga';

export default [
    governanceSaga,
    busStopPerformanceSaga,
    vehicleReportSaga,
];